module.exports = __webpack_public_path__ + "media/images/HBM-d401fad5df658422e854c5f66a448572.png";